import React from "react";
import trans from "../../../../utils";
import { Input, TextAreaInput } from "../../../Helpers/Input/Input";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";

export default function RolesInfo({ addData }) {
	const userType = [
		{ label: trans("Supervisor"), value: "SUPERVISOR" },
		{ label: trans("Field Staff"), value: "FIELD_STAFF" },
		{ label: trans("Customer"), value: "CUSTOMER" },
	];
	return (
		<>
			<div className="userinfo mb-24">
				<p className="fs-16 fw-700 brand-700 text-uppercase">
					{trans("general information")}
				</p>
				<div className="row">
					<div className="col-lg-6">
						<Input
							title={trans("Name")}
							type="text"
							placeholder={trans("Enter role name")}
							formstyle="form-input"
							id="name"
							name="name"
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							errors={addData.errors.name}
							touched={addData.touched.name}
							value={addData.values.name || ""}
						/>
					</div>{" "}
					<div className="col-lg-6">
						<InputSelect
							label={trans("User Type")}
							type="text"
							placeholder={trans("e.g. Supervisor , Field Staff")}
							formstyle="form-input"
							id="userType"
							name="userType"
							options={userType}
							onChange={(e) => {
								addData.setFieldValue("userType", e ?? null);
								addData.setFieldValue("permissions", null);
							}}
							onBlur={addData.handleBlur}
							errors={addData.errors.userType}
							touched={addData.touched.userType}
							value={addData.values.userType || undefined}
							allowClear={false}
						/>
					</div>
					<div className="col-lg-12">
						<TextAreaInput
							title={trans("Description")}
							type="text"
							placeholder={trans("Describe what this permission allows")}
							formstyle="form-input"
							id="description"
							name="description"
							rows={3}
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							errors={addData.errors.description}
							touched={addData.touched.description}
							value={addData.values.description || ""}
						/>
					</div>
				</div>
			</div>
		</>
	);
}
